export default __webpack_public_path__ + "static/media/ictchallenges.03798277.jpg";